<template>
  <div>
    <b-row
      class="mb-1"
      align-content="between"
    >
      <b-col>
        <b-button
          variant="bg-white"
          @click="()=>{
            goToExactParent()
          }"
        >
          <GjIcon
            :key="activeKey"
            class="icon-left"
            name="Close"
          />
          Close
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="margin-top:0px">
        <div class="table-wrapper files-table-wrapper">
          <div class="default-table position-relative">
            <div class="d-flex justify-content-between align-items-center px-2 pt-2 pb-1 mb-1 border-default border-b">
              <directory-breadcrumbs
                :active-key="activeKey"
                :parents="parents "
                :bucket-name="bucketName"
                @backToParent="breadCrumbAction"
                @goToManualPath="goToManualPath"
              />
            </div>
            <div class="px-2 d-flex align-items-center border-default border-b">
              <span
                v-for="tab in tabs"
                :key="`file-tab-${tab.value}`"
                class="pb-1 mr-2 tab-border"
                :class="tab.value === selectedTab ? classes.tabActive : classes.tabInactive"
                @click="selectTab(tab.value)"
              >
                {{ tab.name }}
              </span>
            </div>
            <template>
              <file-properties
                v-if="selectedTab === 0"
                :file="file"
                :account-id="accountId"
              />
              <file-metadata
                v-if="selectedTab === 1"
                :file="file"
                :account-id="accountId"
                @refresh="$emit('refresh')"
              />
              <file-permissions
                v-if="selectedTab === 2"
                :file="file"
                :account-id="accountId"
                @refresh="$emit('refresh')"
              />
              <file-versions
                v-if="selectedTab === 3"
                :file="file"
                :account-id="accountId"
              />
            </template>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import StorageHelpers from '@/mixins/storage-helpers'
import DirectoryBreadcrumbs from '../directory/helpers/DirectoryBreadcrumbs.vue'

// Tab Content
import FileProperties from './FileProperties.vue'
import FileMetadata from './FileMetadata.vue'
import FilePermissions from './FilePermissions.vue'
import FileVersions from './FileVersions.vue'

export default {
  name: 'FilePreview',
  components: {
    DirectoryBreadcrumbs,
    FileProperties,
    FileMetadata,
    FilePermissions,
    FileVersions,
  },
  mixins: [StorageHelpers],
  props: {
    activeKey: {
      type: String,
      default: '',
    },
    parents: {
      type: Array,
      default: null,
    },
    file: {
      type: Object,
      default: null,
      required: true,
    },
    selectedTab: {
      type: [Number, String],
      required: true,
      default: 0,
    },
    accountId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      tabs: [
        {
          name: 'Properties',
          value: 0,
        },
        {
          name: 'Metadata',
          value: 1,
        },
        {
          name: 'Permissions',
          value: 2,
        },
        {
          name: 'Versions',
          value: 3,
        },
      ],
      // selectedTab: 0,
      classes: {
        tabInactive: 'text-secondary cursor-pointer',
        tabActive: 'text-main border-primary border-primary',
      },
    }
  },
  computed: {
    bucketName() {
      return this.$route.params.id
    },
  },
  watch: {

  },
  methods: {
    selectTab(nr) {
      this.$emit('setFilePreviewTab', nr)
    },
    goToExactParent() {
      let path = ''
      if (this.parents.length > 1) {
        const tempParents = [...this.parents]
        path = `${tempParents.splice(0, (tempParents.length - 1)).join('/')}/`
        this.breadCrumbAction(path)
        return
      }
      this.breadCrumbAction(path)
    },
    breadCrumbAction(key) {
      if (key) {
        this.$emit('backToParent', key)
      } else {
        this.$emit('backToParent', null)
      }
    },
    goToManualPath(key) {
      const to = `${key}`
      this.$emit('open', {
        isFolder: true,
        key: to,
      })
    },
  },
}
</script>

<style scoped>
  .tab-border{
    border-top:none !important;
    border-left:none !important;
    border-right:none !important;
    border-bottom-width:2px !important;
    border-color:rgba(0,0,0,0);
    border-style: solid;

  }
</style>
